import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth/auth-context';

/**
 * Gate on every capture route (CA-02 to CA-08). An unauthenticated visitor
 * lands on CA-01 sign-in with the route they wanted, so the sign-in form
 * can send them straight back to it.
 *
 * While the stored session is being restored the gate renders a wait
 * state rather than a redirect. Redirecting first would bounce a
 * signed-in operator to sign-in on every reload, which is the failure
 * this screen exists to prevent.
 */
export function RequireAuth() {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'restoring') {
    return (
      <div className="flex flex-1 items-center justify-center px-6 text-sm text-muted">Restoring your session…</div>
    );
  }

  if (status !== 'signed-in') {
    return <Navigate to="/sign-in" replace state={{ from: `${location.pathname}${location.search}` }} />;
  }

  return <Outlet />;
}
